export const unwrapCallableData = <T>(payload: unknown): T => {
    const body = payload as T | { data?: T };
    if (body && typeof body === 'object' && 'data' in body && body.data) {
        return body.data;
    }
    return body as T;
};

export const getCallableMessage = (payload: unknown): string | undefined => {
    if (payload && typeof payload === 'object' && 'message' in payload) {
        return String((payload as { message?: unknown }).message ?? '');
    }
    return undefined;
};
